// "Coming Soon" banner for the future online courses platform
import { Sparkles } from 'lucide-react'

export function ComingSoonBanner() {
  return (
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-navy via-navy-light to-navy p-6 md:p-8 text-white">
      {/* Decorative circles */}
      <div className="absolute -top-10 -right-10 w-48 h-48 rounded-full bg-primary/10 pointer-events-none" />
      <div className="absolute -bottom-8 -left-8 w-36 h-36 rounded-full bg-primary/10 pointer-events-none" />

      <div className="relative flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex items-center justify-center w-14 h-14 rounded-2xl bg-primary/20 shrink-0">
          <Sparkles className="w-7 h-7 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1 flex-wrap">
            <h3 className="text-lg font-bold text-white">Plataforma de Cursos en Línea</h3>
            <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-primary text-white animate-pulse">
              Muy Pronto
            </span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">
            Próximamente podrás gestionar cursos 100% en línea: inscribir estudiantes, monitorear avances en tiempo real y emitir certificados digitales que se agregan directo a la billetera de su teléfono.
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <div className="text-center">
            <p className="text-3xl font-bold text-primary">2026</p>
            <p className="text-xs text-slate-400 uppercase tracking-wider">Lanzamiento</p>
          </div>
        </div>
      </div>

      <div className="relative mt-5 flex flex-wrap gap-3 text-sm text-slate-400">
        {['Inscripciones en línea', 'Monitoreo en tiempo real', 'Certificados digitales', 'Wallet móvil'].map((feat) => (
          <span key={feat} className="flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-primary inline-block" />
            {feat}
          </span>
        ))}
      </div>
    </div>
  )
}
